/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Table_LockedInputs */



/**
* | output |
* | --- |
* | "Scores on this table were set by a judge and are locked." |
*
* @param {Player_Table_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_table_locked = /** @type {((inputs?: Player_Table_LockedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Table_LockedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les scores de cette table ont été saisis par un arbitre et sont verrouillés.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las puntuaciones de esta mesa fueron establecidas por un juez y están bloqueadas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As pontuações desta mesa foram definidas por um juiz e estão bloqueadas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I punteggi di questo tavolo sono stati impostati da un giudice e sono bloccati.")
	return /** @type {LocalizedString} */ ("Scores on this table were set by a judge and are locked.")
});